import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as constants from '../../helpers/constants';
import Helper from '../../helpers/helper';

import { setMapLayerType, toggleFederalLayer, toggleStateLayer, toggleLGALayer, togglePropertyLayer, toggleHabitatLayer } from '../../actions/mainview/mainview';
import { setSidebarItem } from '../../actions/sidebar/sidebar';

const LayerSwitchItem = () => {

  const dispatch = useDispatch(),
        appProps = useSelector(store => store.app),
        mainviewProps = useSelector(store => store.mainview),
        sidebarProps = useSelector(store => store.sidebar),
        [activeMapType, setActiveMapType] = useState('streets-v11'),
        isAdmin = appProps.loggedInUser?.is_admin,
        isAkf = appProps.loggedInUser?.is_akfstaff,
        isLicensed = appProps.loggedInUser?.is_licenseduser,
        canSeeKHALayers = isAdmin || isAkf || isLicensed;

  const _changeMapLayer = layerString => {
    
    if (mainviewProps.mapStyle === constants.MAPBOX_ROOT_URL + layerString) return false; // prevent switching to same layer

    dispatch(setMapLayerType(constants.MAPBOX_ROOT_URL + layerString));
    setActiveMapType(layerString);
  }

  const _checkForSightingAdd = () => {

    if (mainviewProps.isChoosingLocation) return Helper.setNotification('info', 'Unable to continue', 'Please finish choosing a sighting location before doing anything else.', true);

    dispatch(setSidebarItem(sidebarProps.sidebarItem === 'Layer' ? '' : 'Layer'));
  }

  const itemShown = sidebarProps.sidebarItem === 'Layer';

  return (
    <>
      <span className={ `sidebar__item ${ itemShown ? 'sidebar__item--active' : '' }` } title="Change the current map layer" onClick={ () => _checkForSightingAdd() }>
        <i className="fa fa-layer-group sidebar__icon"></i>
        <span className="sidebar__text">Map layers</span>
      </span>
      
      <div className={`sidebar__sub-nav ${ itemShown ? 'sidebar__sub-nav--show' : '' }`}>
        <span className="sidebar__sub-nav-header">Views</span>
        <span className={ `sidebar__sub-nav-item ${ activeMapType === 'streets-v11' ? 'sidebar__sub-nav-item--active' : '' }` } onClick={ () => _changeMapLayer('streets-v11') }>Map view</span>
        <span className={ `sidebar__sub-nav-item ${ activeMapType === 'satellite-streets-v11' ? 'sidebar__sub-nav-item--active' : '' }` } onClick={ () => _changeMapLayer('satellite-streets-v11') }>Road view</span>
        <span className={ `sidebar__sub-nav-item ${ activeMapType === 'satellite-v9' ? 'sidebar__sub-nav-item--active' : '' }` } onClick={ () => _changeMapLayer('satellite-v9') }>Satellite view</span>
        
        {
          canSeeKHALayers &&
          <>
            <span className="sidebar__sub-nav-header">Koala Habitat</span>
            <span className={ `sidebar__sub-nav-item ${ mainviewProps.showKHAHabitat ? 'sidebar__sub-nav-item--active' : '' }` } onClick={ () => dispatch(toggleHabitatLayer('KHA', !mainviewProps.showKHAHabitat)) }>
              Koala Habitat Atlas (KHA)
            </span>
            <span className={ `sidebar__sub-nav-item ${ mainviewProps.showPreClearingHabitat ? 'sidebar__sub-nav-item--active' : '' }` } onClick={ () => dispatch(toggleHabitatLayer('PreClear', !mainviewProps.showPreClearingHabitat)) }>
              KHA Preclearing Vegetation
            </span>
            <span className={ `sidebar__sub-nav-item ${ mainviewProps.showNVISHabitat ? 'sidebar__sub-nav-item--active' : '' }` } onClick={ () => dispatch(toggleHabitatLayer('NVIS', !mainviewProps.showNVISHabitat)) }>
              Potential Koala Habitat (NVIS)
            </span>
          </>
        }

        <span className="sidebar__sub-nav-header">Boundaries</span>
        <span className={ `sidebar__sub-nav-item ${ mainviewProps.showPropertyLayer ? 'sidebar__sub-nav-item--active' : '' }` } onClick={ () => dispatch(togglePropertyLayer(!mainviewProps.showPropertyLayer)) }>
          Property Boundaries
        </span>
        <span className={ `sidebar__sub-nav-item ${ mainviewProps.showLGALayer ? 'sidebar__sub-nav-item--active' : '' }` } onClick={ () => dispatch(toggleLGALayer(!mainviewProps.showLGALayer)) }>
          Local Governments
        </span>
        <span className={ `sidebar__sub-nav-item ${ mainviewProps.showStateLayer ? 'sidebar__sub-nav-item--active' : '' }` } onClick={ () => dispatch(toggleStateLayer(!mainviewProps.showStateLayer)) }>
          State Electorates
        </span>
        <span className={ `sidebar__sub-nav-item ${ mainviewProps.showFederalLayer ? 'sidebar__sub-nav-item--active' : '' }` } onClick={ () => dispatch(toggleFederalLayer(!mainviewProps.showFederalLayer)) }>
          Federal Electorates
        </span>

      </div>
    </>
  );

}

export default LayerSwitchItem;